/**
 * en-GB messages added by Phase 1 task W3 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w3EnGB = {
    // Field pages
    'fnUi.fields.siteTitle': 'Questions for {site}',
    'fnUi.fields.siteDescription': 'What people are asked when they sign in and out at this site.',
    'fnUi.fields.groupTitle': 'Personal fields for {group}',
    'fnUi.fields.groupDescription': 'Details kept about each member of this group.',
    'fnUi.fields.backToSite': 'Back to {site}',
    'fnUi.fields.backToGroup': 'Back to {group}',
    'fnUi.fields.loadFailed': 'These fields could not be loaded.',
    'fnUi.fields.scope.sign_in': 'Sign-in questions',
    'fnUi.fields.scope.sign_out': 'Sign-out questions',
    'fnUi.fields.scope.personal': 'Personal fields',
    'fnUi.fields.add': 'Add question',
    'fnUi.fields.addPersonal': 'Add field',
    'fnUi.fields.empty': 'No questions yet.',
    'fnUi.fields.emptyPersonal': 'No custom fields yet.',
    'fnUi.fields.counter': '{count} of {max} personal fields used',
    'fnUi.fields.limitReached': 'This group has reached the limit of {max} personal fields.',
    'fnUi.fields.starredCounter': '{count} of {max} starred',
    'fnUi.fields.builtIn': 'Built in',
    'fnUi.fields.builtIn.fullName': 'Full name',
    'fnUi.fields.builtIn.email': 'Email',
    'fnUi.fields.builtIn.phone': 'Phone',
    'fnUi.fields.builtIn.role': 'Role',
    'fnUi.fields.listLabel': '{scope}, in the order they are asked',
    'fnUi.fields.edit': 'Edit {name}',
    'fnUi.fields.star': 'Star {name}',
    'fnUi.fields.unstar': 'Remove star from {name}',
    'fnUi.fields.starTooMany': 'Only {max} fields can be starred.',
    'fnUi.fields.starSensitive': 'Sensitive fields cannot be starred.',
    'fnUi.fields.starNotAllowed': 'This type of field cannot be starred.',
    'fnUi.fields.showArchived': 'Show archived',
    'fnUi.fields.archivedList': 'Archived',
    'fnUi.fields.restore': 'Restore {name}',
    'fnUi.fields.reorderFailed': 'The new order could not be saved.',
    'fnUi.badge.required': 'Required',
    'fnUi.badge.sensitive': 'Sensitive',
    'fnUi.badge.archived': 'Archived',
    // Field dialog
    'fnUi.dialog.addTitle': 'Add question',
    'fnUi.dialog.addPersonalTitle': 'Add personal field',
    'fnUi.dialog.editTitle': 'Edit {name}',
    'fnUi.dialog.pickType': 'What kind of answer?',
    'fnUi.dialog.typeLocked': 'Type: {type}. The type cannot be changed once a question exists.',
    'fnUi.dialog.label': 'Question',
    'fnUi.dialog.labelPersonal': 'Field name',
    'fnUi.dialog.helpText': 'Help text',
    'fnUi.dialog.helpHint': 'Shown under the question. Optional.',
    'fnUi.dialog.required': 'Answer required',
    'fnUi.dialog.sensitive': 'Sensitive',
    'fnUi.dialog.sensitiveHint': 'Answers are stored encrypted and only people who can manage sensitive data can see them.',
    'fnUi.dialog.sensitiveWarning': 'Sensitive answers are hidden from the today board, exports and live updates for most people. They cannot be starred.',
    'fnUi.dialog.groups': 'Ask these groups',
    'fnUi.dialog.groupsHint': 'Choose the groups that see this question at this site.',
    'fnUi.dialog.noGroups': 'There are no groups at this site yet.',
    'fnUi.dialog.settings': 'Settings for this type',
    'fnUi.dialog.preview': 'How it looks on the kiosk',
    'fnUi.dialog.create': 'Add',
    'fnUi.dialog.save': 'Save changes',
    'fnUi.dialog.archive': 'Archive',
    'fnUi.dialog.delete': 'Delete',
    'fnUi.dialog.deleteConfirm': 'Yes, delete it',
    'fnUi.dialog.archiveHint': 'A question with answers cannot be deleted. Archive it to keep the old answers readable.',
    'fnUi.dialog.optionsNeeded': 'Add at least one choice.',
    'fnUi.dialog.close': 'Close dialog',
    // Type cards
    'fnUi.type.text.name': 'Short text',
    'fnUi.type.text.desc': 'A single line, such as a vehicle registration.',
    'fnUi.type.long_text.name': 'Long text',
    'fnUi.type.long_text.desc': 'Several lines, such as a reason for the visit.',
    'fnUi.type.number.name': 'Number',
    'fnUi.type.number.desc': 'A figure, with an optional range and unit.',
    'fnUi.type.email.name': 'Email address',
    'fnUi.type.email.desc': 'Checked to look like an email address.',
    'fnUi.type.phone.name': 'Phone number',
    'fnUi.type.phone.desc': 'A telephone number.',
    'fnUi.type.date.name': 'Date',
    'fnUi.type.date.desc': 'A calendar date.',
    'fnUi.type.select.name': 'Choose one',
    'fnUi.type.select.desc': 'Pick one answer from your own list.',
    'fnUi.type.multi_select.name': 'Choose several',
    'fnUi.type.multi_select.desc': 'Pick any number of answers from your own list.',
    'fnUi.type.yes_no.name': 'Yes or no',
    'fnUi.type.yes_no.desc': 'A simple yes or no question.',
    'fnUi.type.signature.name': 'Signature',
    'fnUi.type.signature.desc': 'The person signs on the screen.',
    'fnUi.type.acknowledge.name': 'Acknowledge',
    'fnUi.type.acknowledge.desc': 'A message the person confirms they have read.',
    'fnUi.type.host.name': 'Who are you visiting',
    'fnUi.type.host.desc': 'Pick a member to notify.',
    // Type settings
    'fnUi.config.maxLength': 'Longest answer (characters)',
    'fnUi.config.min': 'Lowest number',
    'fnUi.config.max': 'Highest number',
    'fnUi.config.integer': 'Whole numbers only',
    'fnUi.config.unit': 'Unit shown after the number',
    'fnUi.config.requiredAnswer': 'Required answer',
    'fnUi.config.requiredAnswer.any': 'Either answer is fine',
    'fnUi.config.requiredAnswer.yes': 'Must be yes',
    'fnUi.config.requiredAnswer.no': 'Must be no',
    'fnUi.config.message': 'Message to acknowledge',
    'fnUi.config.groupIds': 'Groups to pick from',
    'fnUi.config.groupIdsHint': 'Leave all unticked to allow every repeat group.',
    'fnUi.config.options': 'Choices',
    'fnUi.config.optionLabel': 'Choice {n}',
    'fnUi.config.addOption': 'Add choice',
    'fnUi.config.archiveOption': 'Archive {name}',
    'fnUi.config.archivedOptions': 'Archived choices',
    'fnUi.config.restoreOption': 'Restore {name}',
    'fnUi.config.archivedHint': 'Archived choices are not offered, but old answers stay readable.',
    // Preview
    'fnUi.preview.requiredMark': '(required)',
    'fnUi.preview.choose': 'Choose',
    'fnUi.preview.signHere': 'Sign here',
    'fnUi.preview.yes': 'Yes',
    'fnUi.preview.no': 'No',
    'fnUi.preview.iAcknowledge': 'I have read and understood this',
    'fnUi.preview.pickMember': 'Search for a person',
    'fnUi.preview.empty': 'Your question will appear here.',
    // Library
    'fnUi.notices.title': 'Notices',
    'fnUi.notices.description': 'Notices and agreements people read or accept when they sign in.',
    'fnUi.notices.new': 'New notice',
    'fnUi.notices.filter.active': 'Active',
    'fnUi.notices.filter.archived': 'Archived',
    'fnUi.notices.filter.all': 'All notices',
    'fnUi.notices.col.title': 'Title',
    'fnUi.notices.col.version': 'Version',
    'fnUi.notices.col.updated': 'Last updated',
    'fnUi.notices.col.usedIn': 'Where used',
    'fnUi.notices.col.accept': 'Must accept',
    'fnUi.notices.col.signature': 'Signature',
    'fnUi.notices.col.status': 'Status',
    'fnUi.notices.empty': 'No notices yet. Add one to show it at sign-in.',
    'fnUi.notices.notUsed': 'Not used',
    'fnUi.notices.usedItem': '{site}: {group}',
    'fnUi.notices.versionShort': 'v{version}',
    'fnUi.notices.loadFailed': 'Notices could not be loaded.',
    'fnUi.notices.status.active': 'Active',
    'fnUi.notices.status.archived': 'Archived',
    // Editor
    'fnUi.editor.newTitle': 'New notice',
    'fnUi.editor.back': 'All notices',
    'fnUi.editor.titleField': 'Title',
    'fnUi.editor.bodyField': 'Text',
    'fnUi.editor.bodyHint': 'Use the buttons to add bold, italic, headings, lists and links.',
    'fnUi.editor.acceptance': 'People must accept this notice',
    'fnUi.editor.acceptanceHint': 'They tick a box to confirm before they can carry on.',
    'fnUi.editor.signature': 'People must also sign',
    'fnUi.editor.signatureHint': 'They sign on the screen after accepting.',
    'fnUi.editor.create': 'Create notice',
    'fnUi.editor.save': 'Save changes',
    'fnUi.editor.newVersionNote': 'Changing the title or text saves a new version. Earlier versions are kept exactly as they were shown.',
    'fnUi.editor.archive': 'Archive notice',
    'fnUi.editor.restore': 'Restore notice',
    'fnUi.editor.delete': 'Delete notice',
    'fnUi.editor.deleteConfirm': 'Yes, delete it',
    'fnUi.editor.deleteHint': 'A notice that people have accepted cannot be deleted. Archive it instead.',
    'fnUi.editor.loadFailed': 'This notice could not be loaded.',
    'fnUi.editor.toolbar': 'Formatting',
    'fnUi.editor.bold': 'Bold',
    'fnUi.editor.italic': 'Italic',
    'fnUi.editor.heading': 'Heading',
    'fnUi.editor.list': 'Bulleted list',
    'fnUi.editor.link': 'Link',
    'fnUi.editor.sampleBold': 'bold text',
    'fnUi.editor.sampleItalic': 'italic text',
    'fnUi.editor.sampleHeading': 'Heading',
    'fnUi.editor.sampleItem': 'List item',
    'fnUi.editor.sampleLink': 'link text',
    'fnUi.editor.preview': 'Preview',
    'fnUi.editor.previewEmpty': 'The preview appears as you type.',
    // Versions
    'fnUi.versions.title': 'Version history',
    'fnUi.versions.current': 'Current',
    'fnUi.versions.item': 'Version {version}, {when}',
    'fnUi.versions.view': 'View version {version}',
    'fnUi.versions.hide': 'Hide version {version}',
    'fnUi.versions.immutable': 'Old versions cannot be changed.',
    'fnUi.versions.loadFailed': 'The versions could not be loaded.',
    // Site assignments
    'fnUi.assign.title': 'Notices for {site}',
    'fnUi.assign.description': 'Choose which notices each group sees at sign-in, and in what order.',
    'fnUi.assign.back': 'Back to {site}',
    'fnUi.assign.group': 'Notices for {group}',
    'fnUi.assign.listLabel': 'Notices for {group}, in the order shown',
    'fnUi.assign.empty': 'No notices for this group.',
    'fnUi.assign.pick': 'Add a notice for {group}',
    'fnUi.assign.choose': 'Choose a notice',
    'fnUi.assign.addButton': 'Add',
    'fnUi.assign.addTo': 'Add to {group}',
    'fnUi.assign.remove': 'Remove {name} from {group}',
    'fnUi.assign.max': 'A group can have up to {max} notices.',
    'fnUi.assign.noGroups': 'There are no groups to assign notices to.',
    'fnUi.assign.noneToAdd': 'Every active notice is already assigned.',
};
//# sourceMappingURL=w3.js.map